import Logger from '../lib/Logger';
import { getV3SiteKey } from '../store/google-recaptcha/sitekeys';
import { loadScript } from '../utils/loadScript';
export function setupRecaptcha() {
  return loadScript(`https://www.google.com/recaptcha/enterprise.js?render=${getV3SiteKey()}`, `google-recaptcha-enterprise`).catch(error => {
    Logger.getLogger('setupRecaptcha').error(`Error loading recaptcha enterprise. ${error.message}`);
  });
}